import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_AGE006_Request,
  IAPI_AGE006_Response,
  IAPI_RET019_Request,
  IAPI_RET019_Response,
} from "../../../type/apiType";
import {
  IAPI_AGE009_Request,
  IAPI_AGE009_Response,
} from "../../../type/apiType";

// 代行入力依頼新規API
const httpAPI_AGE006 = async (
  param: IAPI_AGE006_Request
): Promise<IAPI_AGE006_Response> => {
  let res = await http.post(ApiUrl.API_AGE006, {
    ...param,
  });
  return res.data;
};

// 代行入力依頼更新API
const httpAPI_AGE009 = async (
  param: IAPI_AGE009_Request
): Promise<IAPI_AGE009_Response> => {
  let res = await http.post(ApiUrl.API_AGE009, {
    ...param,
  });
  return res.data;
};

/**
 * 退職者検索API
 * @returns httpAPI_RET019
 */
const httpAPI_RET019 = async (
  param: IAPI_RET019_Request
): Promise<IAPI_RET019_Response> => {
  let res = await http.post(ApiUrl.API_RET019, {
    ...param,
  });

  return res.data;
};

export { httpAPI_AGE006, httpAPI_AGE009, httpAPI_RET019 };
